<template>
  <div>
    <div class=" dropdown-header noti-title">
      <h6 class="text-overflow m-0">{{ $i18n.t('dashboard.welcome') }}</h6>
    </div>

    <router-link v-if="user && user.uid" :to="{ name: 'user.profile', params: { uid: user.uid } }" replace>
      <div class="dropdown-item">
        <i class="ni ni-single-02"></i>
        <span>{{ $i18n.t('user.profile') }}</span>
      </div>
    </router-link>

    <router-link to="/login" @click.native="logout" replace>
      <div class="dropdown-item">
        <i class="ni ni-user-run"></i>
        <span>{{ $i18n.t('global.logout') }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  created () {
    this.$store.dispatch('fetchUser')
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('userLogout')
    }
  }
}
</script>

<style scoped>
  .cursor-pointer { cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/layouts/Menu.vue